<script>
    // Licensed under Gnu Public License version 2
    // Copyright (c) 2024 (original work) Open Assessment Technologies SA ;

    import { __ } from '@oat-sa-private/ui-core';
    import { Icon } from '@oat-sa-private/ui-elements';

    export let expanded = false;
    export let expandable = false;
    export let disabled = false;
</script>

<style>
    .expand-button-container {
        --local_expand-button-size: var(--expand-button-size, 5.5rem);
        --local_expand-button-width: var(--expand-button-width, var(--local_expand-button-size));
        --local_expand-button-height: var(--expand-button-height, var(--local_expand-button-size));

        width: var(--local_expand-button-width);
        height: var(--local_expand-button-height);

        display: flex;
        justify-content: center;
        align-items: center;
    }

    .dot-icon {
        --local_border-width: var(--dot-icon-border-width, var(--border-medium));
        --local_border-color: var(--dot-icon-border-color, var(--color-text-default));

        width: 0;
        height: 0;
        border: var(--local_border-width) solid var(--local_border-color);
        border-radius: 100%;
    }

    button {
        --local_border-radius: var(--border-radius var(--radius-circular));

        display: flex;
        justify-content: center;
        align-items: center;
        background: none;
        outline: none;
        border: 0;
        width: 100%;
        height: 100%;

        &,
        &:focus-visible::after {
            border-radius: var(--local_border-radius);
        }

        &:focus-visible {
            background-color: var(--color-node-hover);
        }

        &[disabled] {
            & .status {
                --expand-button-color: var(--color-gs-disabled);
            }
        }

        & .status {
            --local_expand-button-status-size: var(--expand-button-status-size, 1.5rem);
            --local_expand-button-status-width: var(
                --expand-button-status-width,
                var(--local_expand-button-status-size)
            );
            --local_expand-button-status-height: var(
                --expand-button-status-height,
                var(--local_expand-button-status-size)
            );
            --local_expand-button-color: var(--expand-button-color, var(--color-text-default));

            width: var(--local_expand-button-status-width);
            height: var(--local_expand-button-status-height);

            display: flex;
            justify-content: center;
            align-items: center;
            transform: rotate(-90deg);

            &.expanded {
                transform: rotate(0deg);
            }
        }
    }

    .expand-button-container :global(button) {
        @add-mixin outline-focus 0;
    }
</style>

<div class="expand-button-container">
    {#if expandable}
        <button on:click aria-label={expanded ? __('Collapse') : __('Expand')} {disabled}>
            <div class="status" class:expanded={expanded && !disabled}>
                <Icon name="caret-down-12" />
            </div>
        </button>
    {:else}
        <div class="dot-icon" />
    {/if}
</div>
